import Api from 'src/util/api';
import { Integer } from 'src/types/base';
import { DateTimeUtil } from 'src/util/dateTimeUtil';

export namespace softwareSecretKeyDOI{
    export interface QueryRowDataParamsI{
        ckb?: Integer;
        dc?: string;
        pw1?: string;
        pw2?: string;
        time?: Integer;
        hour?:Integer;
        min?: Integer;
        month?: Integer;
        hmi?: string;
        mn?: string;
        type?: Integer;
        datetime?: string;
        registration?: string;
    }

    export interface RowDataI {
        secret_key: string;
    }

    export interface serialNumber{
        cpucode: string;
        serial_number: string;
    }

    export interface RowDataIs {
        cpucode: string,
        serial_number: string
        user_name: string
        time: string
        id: number
	}

    export interface QueryRowDataParamsI extends PageDo {
    }
}

export default class softwareSecretKeyApi{
    static async getSecretKey(params: softwareSecretKeyDOI.QueryRowDataParamsI):Promise<softwareSecretKeyDOI.RowDataI>{
        return Api.post("/monitor/software/secret_key/get", {
            ...params,
        });
    }
    static async getModeOne(params: softwareSecretKeyDOI.QueryRowDataParamsI): Promise<softwareSecretKeyDOI.RowDataI>{
        return Api.post("/monitor/software/secret_key/mode_one/get", {
            ...params,
        });
    }
    static async getModeTwo(params: softwareSecretKeyDOI.QueryRowDataParamsI): Promise<softwareSecretKeyDOI.RowDataI>{
        return Api.post("/monitor/software/secret_key/other_mode/get", {
            ...params,
        });
    }
    static async registrationcode(params: softwareSecretKeyDOI.QueryRowDataParamsI): Promise<softwareSecretKeyDOI.RowDataI>{
        var aaa = params.datetime
        return Api.post("/monitor/registration/generate", {
            ...params,
            datetime: DateTimeUtil.formateDate(params.datetime, 'YYYYMMDD'),
        });
    }

    static async getSerialNumber(params: softwareSecretKeyDOI.serialNumber): Promise<any>{
        return Api.post("/monitor/save/serial_number", {
            ...params
        });
    }
    
    static async searchLog(params: softwareSecretKeyDOI.QueryRowDataParamsI):Promise<ResultPageDo<softwareSecretKeyDOI.RowDataIs[]>> {
		return Api.post('/monitor/select/serial_number', {
            ...params
        })
    }
    

}